import React from 'react';
import {FieldValues, SubmitHandler} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';

import ExportResult from '../ExportResult/ExportResult';
import useExportRequest from '../../model/useExportRequest';

import {IMonitorFiltersFormProps} from '../MonitorFiltersFormHandler/MonitorFiltersFormHandler';

export interface IMonitorsExportFormHandlerProps<T extends FieldValues> {
    handleClose: () => void,
    path: string,
    FiltersForm: React.ComponentType<IMonitorFiltersFormProps<T>>,
    buildRequest: (_values: T) => object,
    countLabel: string,
    onExported?: () => void,
}

function MonitorsExportFormHandler<T extends FieldValues>({
    handleClose,
    path,
    FiltersForm,
    buildRequest,
    countLabel,
    onExported,
}: IMonitorsExportFormHandlerProps<T>) {
    const {result, isLoading, progress, submit, reset} = useExportRequest(path);

    const onSubmit: SubmitHandler<T> = async(values) => {
        await submit(buildRequest(values), onExported);
    };

    const handleCloseResult = () => {
        handleClose();
        reset();
    };

    if (result) {
        return <ExportResult result={result} countLabel={countLabel} handleClose={handleCloseResult}/>;
    }

    return (
        <FiltersForm
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Экспортировать`}
                    primaryButtonType="submit"
                    primaryButtonLoading={isLoading}
                    secondaryButtonOnClick={handleClose}
                    progress={progress}
                />
            }
        />
    );
}

export default MonitorsExportFormHandler;
